import React from 'react';

/**
 * Avatar — a gradient initial bubble (Yapp has no profile photos; users
 * are anonymous). Tint by relationship: brand (default), friend (green),
 * anonymous (violet). Pass an emoji to mirror the in-app anonymous emoji.
 */
export function Avatar({
  name = '',
  emoji = null,
  kind = 'brand',
  size = 40,
  style = {},
  ...rest
}) {
  const gradients = {
    brand: 'var(--brand-gradient)',
    friend: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
    anonymous: 'linear-gradient(135deg, #9c27b0 0%, #673ab7 100%)',
  };
  const initial = (name || '?').trim().charAt(0).toUpperCase();

  return (
    <div
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 'var(--radius-pill)',
        background: gradients[kind] || gradients.brand,
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-sans)',
        fontWeight: 'var(--weight-semibold)',
        fontSize: emoji ? size * 0.5 : size * 0.42,
        lineHeight: 1,
        userSelect: 'none',
        ...style,
      }}
      {...rest}
    >
      {emoji || initial}
    </div>
  );
}
